<script>
  import { Popconfirm } from 'element-ui'
  export default {
    name:'ElPopconfirm',
    extends:Popconfirm
  }
</script>
